module.exports = __webpack_public_path__ + "static/media/SIBIRU by HMJ UNPAD.79ce979f.jpeg";